var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 450,
    viewBox: "0 0 271 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.583 267.75V266.915L112.761 266.766C79.4362 260.736 49.5906 242.755 29.0251 216.325C8.46004 189.895 -1.35674 156.904 1.47956 123.766C4.31587 90.6286 19.6032 59.707 44.3745 37.0155C69.1427 14.3268 101.622 1.48826 135.5 1.0001C169.378 1.48826 201.857 14.3268 226.626 37.0155C251.397 59.707 266.684 90.6286 269.52 123.766C272.357 156.904 262.54 189.895 241.975 216.325C221.409 242.755 191.564 260.736 158.239 266.766L157.417 266.915V267.75V427.5C157.417 433.196 155.113 438.663 151.004 442.696C146.895 446.73 141.319 449 135.5 449C129.681 449 124.105 446.73 119.996 442.696C115.887 438.663 113.583 433.196 113.583 427.5V267.75ZM109.487 173.252C117.189 178.304 126.241 181 135.5 181C147.915 181 159.826 176.158 168.61 167.533C177.396 158.908 182.334 147.206 182.334 135C182.334 125.898 179.585 117.002 174.437 109.437C169.288 101.872 161.973 95.9785 153.417 92.4991C144.861 89.0198 135.448 88.1097 126.366 89.8832C117.285 91.6567 108.941 96.0348 102.39 102.467C95.8384 108.899 91.3747 117.096 89.5662 126.022C87.7576 134.949 88.686 144.202 92.2332 152.609C95.7802 161.017 101.786 168.2 109.487 173.252Z",
    fill: "#D71818",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.b5fa38121f64bb77911d232b8d10cf24.svg";
export { ForwardRef as ReactComponent };